import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
// import { Router ,NavigationEnd } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { ThankYouActions } from "./thank-you.actions";
import { MainCampaignActions } from "../main-campaign/main-campaign.actions";
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';



@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
    show_popup:boolean = false;
    popup_image:any;
    url_popup:any;

    constructor(
      private route: ActivatedRoute,
      private store: Store<any>,
      private router: Router,
      private mainCampaignActions: MainCampaignActions,
      private thankYouActions: ThankYouActions,
      private globalService: GlobalService,
      ) {}

    ngOnInit() {

      this.show_popup = this.globalService.getSession('show_popup_thankyoupage') == 1;
      this.popup_image = this.show_popup ? this.globalService.getSession('popup_thankyoupage') : "";
      this.url_popup = this.show_popup ? this.globalService.getSession('link_popup_thankyoupage') : "#";
      
      console.log("Show Popup Thankyou " + this.globalService.getSession('show_popup_thankyoupage'));
      console.log("Image Popup Thankyou " + this.globalService.getSession('popup_thankyoupage'));
      console.log("URL Popup Thankyou " + this.globalService.getSession('link_popup_thankyoupage'));

      if(this.show_popup){
        let element:HTMLElement = document.getElementById('popup-thankyoupage-btn') as HTMLElement;
        element.click();
      }
      
      this.store.dispatch(
        this.thankYouActions.isThankYouPage()
      )

    }

    gotoHomepage(){
      this.router.navigateByUrl("/");
      this.store.dispatch(
        this.mainCampaignActions.reset()
      );
    }

}
